<template>
  <div class="info-line-action">
    <InputFlat
      :label="additional?.description || TranslatesList[data.title.replace('lang.', '')] || data.title"
      :required="additional?.isUserRequired"
      :privacy="data?.hasPrivacy"
      hide-input
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import InputFlat from 'features/settings/mobile-editor/components/right-side/components/input-flat.vue';
import { AdditionsList, TranslatesList } from 'features/settings/mobile-editor/requests';
import { InfoLineActionWidget } from 'features/settings/mobile-editor/interfaces';

export default defineComponent({
  name: 'InfoLineAction',
  components: { InputFlat },
  props: {
    data: {
      type: Object as PropType<InfoLineActionWidget>,
      required: true,
    },
  },
  setup (props) {
    const additional = AdditionsList.find((a) => props.data.text === a.formCode);

    return {
      additional,
      TranslatesList,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
